import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import CustomLayout from "../../components/layout";
import CreditReissueConfiguration from "./credit-reissue-configuration";
import { selectUserDetails } from "../../features/auth/authSlice";
import {
	TPO_COMPANY_ADMIN_USER_TITLE,
	TPO_LOAN_OFFICER_USER_TITLE,
	TPO_LOAN_PROCESSOR_USER_TITLE,
	COMPANY_ADMIN
} from "../../utils/common-constants";
import styles from "./index.module.scss";

const Settings = () => {
	const userDetails = useSelector(selectUserDetails);
	const userTitles = Array.isArray(userDetails?.user_title)
		? userDetails.user_title
		: [];
	const isCompanyAdmin = userDetails?.access_level === COMPANY_ADMIN;
	const isLoanOfficerOrProcessor =
		userTitles.includes(TPO_LOAN_OFFICER_USER_TITLE) ||
		userTitles.includes(TPO_LOAN_PROCESSOR_USER_TITLE);

	return (
		<CustomLayout breadcrumb={[{ label: "Settings", path: "/settings" }]}>
		<div className={styles.settingsPage}>
			<nav className={styles.navigation} aria-label="Settings">
				<p className={styles.navigationTitle}>Settings</p>
				<Link to="/settings" aria-current="page" className={styles.activeItem}>
					Credit Reissue
					<br />
					Configuration
				</Link>
			</nav>
			<CreditReissueConfiguration
				isCompanyAdmin={isCompanyAdmin}
				isLoanOfficerOrProcessor={isLoanOfficerOrProcessor}
			/>
		</div>
		</CustomLayout>
	);
};

export default Settings;
